<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div class="container_info_azul">
          {{ $t('Configura los servicios que realiza este empleado para tu sistema de reservas online.') }}
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <TablaServiciosOnlineEmpleado
            :selected_filters="{'is_active': true, 'is_disponible_online': true}"
            :empleado="empleado"

        />
      </v-col>
    </v-row>
  </div>
</template>


<script>
export default {
  name: 'TabServiciosOnlineEmpleado',
  props: {
    empleado: {
      type: Object,
      required: true
    }
  },

  components: {
    TablaServiciosOnlineEmpleado: () => import('@/views/Configuracion/Empleados/components/TablaServiciosOnlineEmpleado')
  }
}
</script>
